import { render, staticRenderFns } from "./TDSSpinner.vue?vue&type=template&id=31560593&scoped=true&"
import script from "./TDSSpinner.vue?vue&type=script&lang=ts&"
export * from "./TDSSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./TDSSpinner.vue?vue&type=style&index=0&id=31560593&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31560593",
  null
  
)

export default component.exports